import { render, staticRenderFns } from "./biNewsSearch.vue?vue&type=template&id=729c3855&scoped=true&"
import script from "./biNewsSearch.vue?vue&type=script&lang=js&"
export * from "./biNewsSearch.vue?vue&type=script&lang=js&"
import style0 from "./biNewsSearch.vue?vue&type=style&index=0&id=729c3855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c3855",
  null
  
)

export default component.exports